import { lazy, useEffect, useState } from "react";

const EmojiPicker = lazy(() => import("@emoji-mart/react"));

export function LazyEmojiPicker({ onSelect }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;

    import("@emoji-mart/data").then((module) => {
      if (mounted) setData(module.default);
    });

    return () => {
      mounted = false;
    };
  }, []);

  if (!data) return null;

  return (
    <EmojiPicker
      data={data}
      onEmojiSelect={onSelect}
      theme="light"
      previewPosition="none"
      style={{
        maxWidth: "100%",
      }}
    />
  );
}
